import React, { useState } from 'react';
import dayjs from 'dayjs';
import { Menu, MenuGap, MenuItemWrapper, SubmitButton } from './filterMenuFieldStyle';
import moment from 'moment';
import { useUserContext } from '../../../hooks/UserContext';
import { useQuery } from 'react-query';
import PremiseService from '../../../services/bioplus-services/premise';
import GeofenceServices from '../../../services/bioplus-services/geofence';
import { FilterIcon } from '../../icons';
import IconButton from '../iconButton';
import InputField from '../inputField';
import DropDown from '../dropDown';
import DateUtils from '../../../utils/date-utils';
import { editGeofenceFormatData } from '../../../helper/dataFormat';
import { IntlMessages } from '../../../helper/langHelper';

const FilterMenuField = (props) => {
  const { handleFilterParams, isOnlyDate = false } = props;
  const [fromDate, setFromDate] = useState(
    moment(dayjs().subtract(7, 'day')?.$d).format('YYYY-MM-DD')
  );
  const [toDate, setToDate] = React.useState(moment(DateUtils.today?.$d).format('YYYY-MM-DD'));
  const [premises, setPremises] = useState('');
  const [geoFence, setGeoFence] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  // to get the company id
  const userContext = useUserContext();
  const userRole = userContext?.company;
  const companyId = userRole?.companyId?.id;
  const { data: premisesData } = useQuery(['premises', companyId], () =>
    PremiseService.listByCompany(companyId)
  );

  const { data: geoFencesData } = useQuery(
    ['geofence', premises],
    () => GeofenceServices.getGeofencesByPremiseId(premises),
    {
      enabled: !!premises,
    }
  );

  const handleButtonClick = () => {
    setIsOpen(!isOpen);
  };

  const handleSubmit = () => {
    handleFilterParams({
      fromDate,
      toDate,
      geoFence,
      premises,
    });
    setIsOpen(false);
  };

  return (
    <>
      <IconButton
        onClick={handleButtonClick}
        text={<IntlMessages id="button.text.apply.filter" />}
        icon={<FilterIcon />}
      />
      {isOpen && (
        <Menu className="hide-scroll-bar" isOnlyDate={isOnlyDate}>
          <MenuGap>
            <MenuItemWrapper>
              <InputField
                type="date"
                Name={<IntlMessages id="input.label.from.date" />}
                onChange={(e) => setFromDate(e.target.value)}
                value={fromDate}
              />
              <InputField
                type="date"
                Name={<IntlMessages id="input.label.to.date" />}
                onChange={(e) => setToDate(e.target.value)}
                value={toDate}
              />
            </MenuItemWrapper>
            {!isOnlyDate && (
              <MenuItemWrapper>
                <DropDown
                  options={editGeofenceFormatData(geoFencesData?.items)}
                  selectedOption={(value) => setGeoFence(value.value)}
                  placeholder="Select Geofence"
                />
                <DropDown
                  options={editGeofenceFormatData(premisesData?.items)}
                  selectedOption={(value) => setPremises(value.value)}
                  placeholder="Select Premise"
                />
              </MenuItemWrapper>
            )}
          </MenuGap>
          <SubmitButton onClick={handleSubmit} varient="normal">
            <IntlMessages id="button.text.apply.filter" />
          </SubmitButton>
        </Menu>
      )}
    </>
  );
};

export default FilterMenuField;
